<div class="secondary-container">
  <div class="mb-3">
    <div class="row">
      <div class="col-12 col-md-8">
        <app-title title="{{ selectedName }}" small="{{ subtitleKey() | translate }}">
        </app-title>
      </div>
      <div class="col-12 col-md-4 d-flex justify-content-end align-items-center gap-6">
        <button
          class="btn btn-primary mx-1 d-flex justify-content-between align-items-center"
          *ngIf="selectedTableType == 4"
          style="width: 250px"
          (click)="downloadWaterwiseValuesReport()"
        >
          {{ "alerts.home.waterwise-values-report" | translate }}
          <i class="fa fa-file" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="secondary-header-buttons flex-column align-items-end">
      <div class="d-flex flex-wrap gap-6">
        <button
          class="btn btn-primary mx-1 d-flex justify-content-between align-items-center"
          *ngIf="storageService.isAdmin() && selectedTableType == 2"
          style="width: 250px"
          (click)="Modal(dateReport, 'show')"
        >
          {{ "alerts.home.alert-report" | translate }}
          <i class="fa fa-file" aria-hidden="true"></i>
        </button>

        <button
          *ngIf="feedersHome.length > 0 && selectedItems.length > 0"
          class="btn btn-secondary"
          (click)="validateShowModalBattery()"
        >
          {{ "alerts.actions.modal-batery-panel" | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="d-flex nav-root simple-border">
    <div
      *ngFor="let item of sections"
      class="nav-item"
      [ngClass]="{
        'bg-primary': validateBackgroundNav(section.id, item.id)
      }"
      (click)="onSectionClick(item)"
    >
      {{ item.label | translate }}

      <em class="fa fa-angle-down ms-2" *ngIf="item.submenu?.length"></em>

      <ul *ngIf="item.submenu?.length" class="submenu list-unstyled m-0 p-0">
        <li *ngFor="let sub of item.submenu" (click)="onSubmenuClick(sub, item, $event)">
          <a
            class="submenu-item d-block px-3 py-2"
            *ngIf="!sub.requiresAdmin || storageService.validateSoloAdmin()"
          >
            {{ sub.label | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div class="bg-white mb-3 simple-border">
    <form [formGroup]="FormSearch" class="p-3">
      <!-- Barra visible: tipo en sensores y los filtros marcados en el panel (la busqueda por defecto) -->
      <div class="filter-main">
        <div class="flex-item" *ngIf="selectedTableType == 3">
          <div class="floating-label">
            <select class="form-control" formControlName="kind" #c (change)="getData()">
              <option value="">{{ "general.all" | translate }}</option>
              <option *ngFor="let item of kindItems" [value]="item.value">
                {{ item.label | translate }}
              </option>
            </select>
            <span>{{ "filter.type" | translate }}</span>
          </div>
        </div>
        <!-- Filtros que el usuario eligio mostrar en la barra (checks del panel) -->
        <ng-container appFilterSlot #filterSlot="filterSlot"></ng-container>
        <button
          type="button"
          class="filter-toggle"
          [attr.aria-label]="'filter.filters' | translate"
          (click)="openFilters = true"
        >
          <em class="fa fa-filter"></em>
          <span class="filter-toggle-badge" *ngIf="activeFilters">{{ activeFilters }}</span>
        </button>
      </div>

      <app-filter-sidebar
        [open]="openFilters"
        (closed)="openFilters = false"
        (cleared)="clearFilters()"
      >
        <!-- Cada filtro se declara una vez; segun los checks del panel se pinta aqui o en la barra -->
        <ng-container *ngIf="selectedTableType != 3">
          <div
            class="flex-item"
            *appFilterItem="'search'; label: 'filter.search'; slot: filterSlot; default: true"
          >
            <div class="floating-label">
              <input
                type="search"
                formControlName="advanced"
                name="advanced"
                class="form-control"
                placeholder=" "
                (keyup.enter)="getData()"
              />
              <span>{{ searchLabelKey() | translate }}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedTableType == 1">
          <div class="flex-item" *appFilterItem="'order'; label: 'filter.order'; slot: filterSlot">
            <div class="floating-label">
              <select
                type="search"
                name="orderingAdvance"
                formControlName="orderingAdvance"
                class="form-control"
                (change)="setValueOrderinAdvance($event.target)"
              >
                <option value="">{{ "filter.no-order" | translate }}</option>
                <option value="name_advance">
                  {{ "filter.feeder-name" | translate }}
                </option>
                <option value="pond_number">
                  {{ "filter.pond-number" | translate }}
                </option>
                <option value="pond">
                  {{ "filter.pond-name" | translate }}
                </option>
                <option value="-alert_rank" *ngIf="storageService.validateSoloAdmin()">
                  {{ "filter.count-alerts" | translate }}
                </option>
                <option value="-alert_sprinkle,-alert_comm,-alert_reset,-alert_dispenser">
                  {{ "filter.alert-rank" | translate }}
                </option>
              </select>
              <span>{{ "filter.order" | translate }}</span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="selectedTableType == 2">
          <div
            class="flex-item"
            *appFilterItem="'alert_type'; label: 'filter.type'; slot: filterSlot"
          >
            <div class="floating-label">
              <select class="form-control" formControlName="typeAlert" (change)="getData()">
                <option value="">{{ "general.all" | translate }}</option>
                <option value="dispenser">
                  {{ "alerts.general.dispenser" | translate }}
                </option>
                <option value="sprinkler">
                  {{ "alerts.general.sprinkler" | translate }}
                </option>
                <option value="communication">
                  {{ "alerts.general.communication" | translate }}
                </option>
                <option value="battery">
                  {{ "alerts.general.battery" | translate }}
                </option>
                <option value="panel">{{ "alerts.general.panel" | translate }}</option>
                <option value="reset">
                  {{ "alerts.general.reboot" | translate }}
                </option>
              </select>
              <span>{{ "filter.type" | translate }}</span>
            </div>
          </div>

          <div
            class="flex-item"
            *appFilterItem="'repeated'; label: 'alerts.general.repeated'; slot: filterSlot"
          >
            <div class="floating-label">
              <select class="form-control" formControlName="category" (change)="getData()">
                <option value="">{{ "general.all" | translate }}</option>
                <option value="1">{{ "general.show" | translate }}</option>
                <option value="0">{{ "general.hide" | translate }}</option>
              </select>
              <span>{{ "alerts.general.repeated" | translate }}</span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="selectedTableType == 3 && !storageService.isAdmin()">
          <div class="flex-item" *appFilterItem="'cycle'; label: 'filter.cycle'; slot: filterSlot">
            <div class="floating-label">
              <select
                class="form-control"
                formControlName="cycle_id"
                (change)="changeCycleSelect()"
              >
                <option *ngFor="let item of cycles" [value]="item.id">
                  {{ item.name }}
                </option>
              </select>
              <span>{{ "filter.cycle" | translate }}</span>
            </div>
          </div>
        </ng-container>

        <!-- Rango de fechas: no aplica a dispositivos (estado actual) de alimentadores ni hidrofonos -->
        <ng-container *ngIf="selectedTableType != 1 && selectedTableType != 7">
          <div
            class="flex-datetime"
            *appFilterItem="'dates'; label: 'filter.date-range'; slot: filterSlot"
          >
            <div class="flex-item">
              <div class="floating-label">
                <input
                  type="date"
                  formControlName="dateCreated"
                  class="form-control"
                  placeholder=" "
                  (change)="getData()"
                />
                <span>{{ "filter.init-date" | translate }}</span>
              </div>
            </div>
            <div class="flex-item">
              <div class="floating-label">
                <input
                  type="date"
                  formControlName="finishCreated"
                  class="form-control"
                  placeholder=" "
                  (change)="getData()"
                />
                <span>{{ "filter.finish-date" | translate }}</span>
              </div>
            </div>
            <div class="filter-refresh">
              <em
                class="fa fa-retweet p-2 mt-auto mb-2 c-pointer"
                (click)="
                  FormSearch.controls['dateCreated'].setValue('');
                  FormSearch.controls['finishCreated'].setValue('')
                "
              ></em>
            </div>
          </div>
        </ng-container>

        <div
          class="d-flex align-items-center"
          *ngIf="loadingFormClients && storageService.isAdmin()"
        >
          <app-spinner [smallLoader]="true"></app-spinner>
        </div>

        <ng-container *ngIf="storageService.isAdmin() && clients.length > 0">
          <div class="flex-item" *appFilterItem="'client'; label: 'filter.client'; slot: filterSlot">
            <app-search-select
              [items]="clients"
              [displayKey]="'name'"
              [valueKey]="'id'"
              [label]="'filter.client' | translate"
              [placeholder]="'alerts.home.select-client-placeholder' | translate"
              formControlName="client_id"
              (itemSelected)="onClientSelected($event)"
            >
            </app-search-select>
          </div>
        </ng-container>

        <div class="d-flex align-items-center" *ngIf="loadingFormFarms && storageService.isAdmin()">
          <app-spinner [smallLoader]="true"></app-spinner>
        </div>

        <ng-container *ngIf="storageService.isAdmin() && clientFarms.length > 0">
          <div class="flex-item" *appFilterItem="'farm'; label: 'filter.farm'; slot: filterSlot">
            <div class="floating-label">
              <select
                class="form-control"
                formControlName="farm_id"
                #c
                [disabled]="!clientID"
                (change)="
                  FormSearch.controls['farm_id'].setValue(c.value);
                  FormSearch.controls['pond_id'].setValue('');
                  selectedFarm(c.value, 1)
                "
              >
                <option value="">{{ "general.all" | translate }}</option>
                <option *ngFor="let item of clientFarms" [value]="item.id">
                  {{ item.name }}
                </option>
              </select>
              <span>{{ "filter.farm" | translate }}</span>
            </div>
          </div>
        </ng-container>

        <div class="d-flex align-items-center" *ngIf="loadingFormPonds">
          <app-spinner [smallLoader]="true"></app-spinner>
        </div>

        <ng-container *ngIf="clientFarmPonds.length > 0">
          <div class="flex-item" *appFilterItem="'pond'; label: 'filter.pond'; slot: filterSlot">
            <app-pond-select
              [items]="clientFarmPonds"
              [label]="'filter.pond' | translate"
              [placeholder]="'alerts.home.all-ponds-placeholder' | translate"
              formControlName="pond_id"
              (itemSelected)="selectedPond($event)"
            >
            </app-pond-select>
          </div>
        </ng-container>
      </app-filter-sidebar>
    </form>

    <!--   <app-spinner
    *ngIf="loadingData && selectedTableType !== 1"
    [vh]="'h-50vh'"
    [spinnerColor]="'text-primary'"
    [showSmall]="true"
    [errorText]="dataErrorMessage.errorMessage"
    [status]="dataErrorMessage.error"
    [type]="selectedName"
  >
  </app-spinner>
 -->

    <div class="bg-white mt-3">
      <app-table-feeders
        *ngIf="selectedTableType == 1"
        [pageSize]="pageSize"
        [ordering]="textQueryAlerts"
        [loading]="loadingData"
        [count]="count"
        [list]="feeders"
        [page]="pagination"
        (onChangeSize)="changeSize($event)"
        (onChangePagination)="getlistpagination($event)"
        (onChangeOrdering)="changeOrdering($event)"
      >
      </app-table-feeders>

      <app-table-waterwises
        *ngIf="selectedTableType == 4"
        [list]="waterwises"
        [pageSize]="pageSize"
        [loading]="loadingData"
        [count]="count"
        [page]="pagination"
        (onChangeSize)="changeSize($event)"
        (onChangePagination)="getlistpagination($event)"
      >
      </app-table-waterwises>
      <app-table-hydros
        *ngIf="selectedTableType == 7"
        [list]="hydros"
        [pageSize]="pageSize"
        [loading]="loadingData"
        [count]="count"
        [page]="pagination"
        (sizeChange)="changeSize($event)"
        (paginationChange)="getlistpagination($event)"
      >
      </app-table-hydros>
      <app-historical
        *ngIf="selectedTableType == 2"
        [list]="historicalAlerts"
        [pageSize]="pageSize"
        [loading]="loadingData"
        [count]="count"
        [page]="pagination"
        (onChangeSize)="changeSize($event)"
        (onChangePagination)="getlistpagination($event)"
      >
      </app-historical>

      <app-historical-waterwise
        *ngIf="selectedTableType == 6"
        [list]="historicalAlerts"
        [pageSize]="pageSize"
        [loading]="loadingData"
        [count]="count"
        [page]="pagination"
        (onChangeSize)="changeSize($event)"
        (onChangePagination)="getlistpagination($event)"
      >
      </app-historical-waterwise>

      <app-sensors-alerts
        *ngIf="selectedTableType == 5"
        [list]="sensorsAlerts"
        [pageSize]="pageSize"
        [loading]="loadingData"
        [count]="count"
        [page]="pagination"
        (onChangeSize)="changeSize($event)"
        (onChangePagination)="getlistpagination($event)"
      >
      </app-sensors-alerts>

      <app-parametrics
        *ngIf="selectedTableType == 3"
        [list]="parametricsAlerts"
        [pageSize]="pageSize"
        [loading]="loadingData"
        [count]="count"
        [page]="pagination"
        (onChangeSize)="changeSize($event)"
        (onChangePagination)="getlistpagination($event)"
      >
      </app-parametrics>
    </div>
  </div>
</div>

<div
  class="floating-selected bottom-sheet animate__animated animate__fadeIn"
  style="z-index: 1001"
  [class]="minimizedFeeders ? 'opened-card ' : 'minimized'"
  *ngIf="selectedItems.length > 0 && selectedItems"
>
  <div class="card selected-card mb-0">
    <div
      class="card-header bg-primary text-white d-flex justify-content-between align-items-center p-3 gap-10 c-pointer"
      appSheetSwipe
      (swipeUp)="minimizedFeeders = true"
      (swipeDown)="minimizedFeeders = false"
      (click)="minimizedFeeders = !minimizedFeeders"
    >
      <div>
        <h5 class="mb-0 font-weight-bold">
          {{ "alerts.general.multiple-operations" | translate }}
        </h5>
        <small *ngIf="selectedTableType === 1">
          {{ "alerts.general.selected-feeders" | translate }}:
          <span class="text-success font-weight-bold">{{ selectedItems.length }}</span>
        </small>
        <small *ngIf="selectedTableType === 4">
          {{ "alerts.general.selected-waterwises" | translate }}:
          <span class="text-success font-weight-bold">{{ selectedItems.length }}</span>
        </small>
      </div>
      <span
        class="c-pointer text-white bottom-sheet-toggle"
        style="font-size: 1.5rem; line-height: 1"
        role="button"
        tabindex="0"
        [attr.aria-label]="(minimizedFeeders ? 'general.minimize' : 'general.expand') | translate"
        (keydown.enter)="minimizedFeeders = !minimizedFeeders"
      >
        <ng-container *ngIf="minimizedFeeders">&times;</ng-container>
        <i
          *ngIf="!minimizedFeeders"
          class="fa fa-chevron-up"
          aria-hidden="true"
          style="font-size: 15px"
        ></i>
      </span>
    </div>
    <div class="card-body p-0 bottom-sheet-list" *ngIf="minimizedFeeders">
      <ul class="list-unstyled mb-0 pl-0">
        <li
          class="feeder-list-item d-flex justify-content-between align-items-center c-pointer p-2"
          *ngFor="let item of selectedItems"
        >
          {{ item.name }}
          <i class="fa fa-minus-circle text-danger" aria-hidden="true" (click)="removeDevice(item.id)"></i>
        </li>
      </ul>
    </div>
    <div class="card-footer p-2" *ngIf="minimizedFeeders">
      <ng-container *ngIf="validateSelectFeeders()">
        <div class="d-flex flex-wrap justify-content-center mb-2" style="gap: 6px">
          <button
            *ngIf="permissions.change_alert && (selectedTableType == 1 || selectedTableType == 4)"
            type="button"
            class="btn btn-primary btn-sm flex-fill"
            (click)="showPanelAlerts()"
          >
            {{ "alerts.actions.test" | translate }}
            <img class="ml-2" src="assets/img/icons/test.svg" alt="test" width="18" />
          </button>
          <button
            type="button"
            class="btn btn-dark btn-sm flex-fill"
            [disabled]="loadingSettings"
            (click)="
              openSettingsModal(
                selectedTableType == 1 ? modalSettings : modalSettingsWaterwise,
                selectedTableType == 1 ? 'xl' : 'lg'
              )
            "
            *ngIf="globalFunction.validateSoloAdmin()"
          >
            {{ "alerts.actions.settings" | translate }}
            <i class="fa ml-1" [ngClass]="loadingSettings ? 'fa-spinner fa-spin' : 'fa-cog'"></i>
          </button>
          <button
            *ngIf="permissions.view_tests && selectedTableType === 1"
            type="button"
            [disabled]="waiting"
            class="btn btn-secondary btn-sm flex-fill"
            (click)="resetFeeders(selectedItems)"
          >
            {{ "alerts.actions.reset" | translate }}
            <i class="fas fa-sync-alt ml-1"></i>
          </button>
        </div>
      </ng-container>
      <button class="btn btn-warning btn-sm btn-block" type="button" (click)="resetSelected()">
        {{ "alerts.actions.remove" | translate }}
      </button>
    </div>
  </div>
</div>

<app-panel-alerts
  *ngIf="viewModalPanel"
  (closed)="closePanel()"
  [list]="selectedItems"
></app-panel-alerts>

<app-frames-device-dynamic
  *ngIf="viewModalTestDevice"
  [devices]="selectedItems"
  (closed)="closePanel()"
  [type]="'waterwise'"
></app-frames-device-dynamic>

<ng-template #modalSettings>
  <div class="modal-header d-flex bg-primary p-2 align-items-center text-center">
    <div
      class="text d-flex gap-10 justify-content-center align-items-center"
      style="width: -webkit-fill-available"
    >
      <h3 class="m-0 p-3">{{ "alerts.actions.settings" | translate }}</h3>
      <span
        class="badge badge-dark c-pointer help-badge"
        placement="bottom"
        ngbTooltip="{{ 'tooltip.test' | translate }}."
        >?</span
      >
    </div>
    <h3 class="m-0 c-pointer" (click)="Modal(establi, 'hide')">&times;</h3>
  </div>
  <div class="modal-body">
    <app-settings-modal
      [selectedFeeders]="selectedItems"
      [type]="'feeder'"
      (updateList)="getData()"
    >
    </app-settings-modal>
  </div>
</ng-template>

<ng-template #modalSettingsWaterwise>
  <div class="modal-header d-flex bg-primary p-2 align-items-center text-center">
    <div class="text" style="width: -webkit-fill-available">
      <h3 class="m-0">
        {{ "alerts.actions.settings" | translate }}
        <span
          class="badge badge-dark position-absolute c-pointer help-badge"
          placement="bottom"
          ngbTooltip="{{ 'tooltip.test' | translate }}."
          >?</span
        >
      </h3>
      <small>{{ "alerts.general.subtitle-device" | translate }}</small>
    </div>
    <h3 class="m-0 c-pointer" (click)="Modal(establi, 'hide')">&times;</h3>
  </div>
  <div class="modal-body">
    <app-config-sensors-device
      [selectedItems]="selectedItems"
      [type]="'waterwise'"
      [massiveUpdate]="true"
    >
    </app-config-sensors-device>
  </div>
</ng-template>

<ng-template #dateReport>
  <div class="modal-header d-flex bg-primary p-2 align-items-center text-center">
    <div class="text" style="width: -webkit-fill-available">
      <h3 class="m-0">{{ "alerts.home.alert-report" | translate }}</h3>
    </div>
    <h3 class="m-0 c-pointer" (click)="Modal(establi, 'hide')">&times;</h3>
  </div>

  <div class="modal-body">
    <app-historical-inform-modal [clients]="clients"></app-historical-inform-modal>
  </div>
</ng-template>

<ng-template #modalBatteryPanel>
  <div class="modal-header d-flex bg-primary p-2 align-items-center text-center">
    <div class="text" style="width: -webkit-fill-available">
      <h3 class="m-0">{{ "alerts.actions.modal-batery-panel" | translate }}</h3>
    </div>
    <h3 class="m-0 c-pointer" (click)="Modal(establi, 'hide')">&times;</h3>
  </div>
  <div class="modal-body">
    <form [formGroup]="searchGraph">
      <div class="row">
        <div class="col-3">
          <div class="floating-label">
            <select
              class="form-control"
              name="resample_rule"
              formControlName="resample_rule"
              id=""
              (change)="chageSelect($event.target)"
            >
              <option value="M">{{ "filter.month" | translate }}</option>
              <option value="W">{{ "filter.week" | translate }}</option>
              <option value="D">{{ "filter.days" | translate }}</option>
              <option value="H">{{ "filter.hours" | translate }}</option>
              <option value="T">{{ "filter.minutes" | translate }}</option>
            </select>
            <span>{{ "filter.filter" | translate }}</span>
          </div>
        </div>
        <div class="col-3">
          <div class="floating-label">
            <input
              class="form-control mr-2"
              type="number"
              formControlName="value_rule"
              placeholder=" "
            />
            <span>{{ "words.to" | translate }}</span>
          </div>
        </div>
        <div class="col-5">
          <div class="row p-0">
            <div class="col-6 p-0">
              <div class="floating-label">
                <input
                  class="form-control mr-1"
                  type="date"
                  formControlName="start_date"
                  placeholder=" "
                />
                <span>{{ "words.from" | translate }}</span>
              </div>
            </div>
            <div class="col-6 p-0">
              <div class="floating-label">
                <input
                  class="form-control ml-1"
                  type="date"
                  formControlName="finish_date"
                  placeholder=" "
                />
                <span>{{ "words.to" | translate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-1 d-flex align-items-end justify-content-end p-0">
          <button
            class="btn btn-primary mt-2"
            [disabled]="!validateButtonSubmit()"
            (click)="getGraph('battery', false); getGraph('panel', false)"
          >
            <em class="fa fa-search"></em>
          </button>
        </div>
        <div class="col-12">
          <div *ngIf="feedersHome.length > 0">
            <span>{{ "alerts.home.selected-feeders-label" | translate }}</span>
            <div>
              <span
                class="badge badge-warning mr-1 c-pointer"
                *ngFor="let item of feedersHome; let i = index"
                (click)="deleteItem(i)"
                [style.backgroundColor]="item.color"
                >{{ item.name }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </form>

    <app-echar
      [labels]="dataGraph.battery.labels"
      [data]="dataGraph.battery.data"
      [height]="540"
      [heightStyle]="'px'"
    ></app-echar>
    <app-echar
      [labels]="dataGraph.panel.labels"
      [data]="dataGraph.panel.data"
      [height]="540"
      [heightStyle]="'px'"
    ></app-echar>
  </div>
</ng-template>
